export default __webpack_public_path__ + "static/media/night-loading-icon.4c3e76fe.svg";